import { render, staticRenderFns } from "./ItemsIndex.vue?vue&type=template&id=3494edf6"
import script from "./ItemsIndex.vue?vue&type=script&lang=js"
export * from "./ItemsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports